export * from './detail/detail.page';
export * from './orders/orders.page';
